export const EmailTemplateRoutes = {
  LIST: "/email-templates",
  CREATE: "/email-templates/new",
  EDIT: "/email-templates/:id",
  AIRLINES: "/settings/airlines",
  BRAND: "/settings/email-brand",
} as const;
